import React from 'react'
import { AuthStoreContext } from './AuthStoreProvider'

export function withAuthStore(Component) {
  return function AuthStoreWrapper({ ...props }) {
    return (
      <AuthStoreContext.Consumer>
        {state => <Component {...props} {...state} />}
      </AuthStoreContext.Consumer>
    )
  }
}
